export default (theme) => ({
  crossedOut: {
    textDecoration: 'line-through',
    color: theme.color.grey_8A,
  },
  adjusted: {
    paddingLeft: 3,
  },
});
